/**
 * Shared utility helpers and types for MaintenancePillarPanel details views.
 */

export interface PillarDetailsCommonProps {
  metricBg: string;
  trackColor: string;
  theme: string;
  score: number;
}

export function safeNum(value: unknown): number | null {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    if (!isNaN(parsed)) return parsed;
  }
  return null;
}

export function formatHours(hours: number | null): string {
  if (hours === null || hours === undefined) return 'N/A';
  if (hours < 24) return `${Math.round(hours)}h`;
  const days = Math.round(hours / 24);
  return `${days}d`;
}

export function formatAge(years: number | null | undefined): { value: string; unit: string } {
  if (years === null || years === undefined) {
    return { value: 'N/A', unit: '' };
  }
  if (years < 1) {
    const months = Math.round(years * 12);
    return { value: String(months), unit: months === 1 ? 'month' : 'months' };
  }
  return { value: years.toFixed(1), unit: 'years' };
}
